import React, { useEffect, useRef } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { INTRO, focusIn } from '../utils/reveal';
import { useIsMobile } from '../hooks/useIsMobile';
import { madness } from '../utils/madness';

/** Cursor within this distance (px) of CONTACT counts as "getting close" for Pixel's anger */
const PROXIMITY_RANGE = 520;

/** Top-right: a single black CONTACT pill. Hover: it fades very slightly. */
export function NavBar() {
  const reduce = useReducedMotion();
  const contactRef = useRef<HTMLAnchorElement>(null);
  const mobile = useIsMobile();

  // Tell Pixel how close the cursor is to CONTACT (he gets angrier the closer you tease it)
  useEffect(() => {
    const onMove = (e: PointerEvent) => {
      const el = contactRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      madness.setContact((r.left + r.width / 2) / window.innerWidth * 2 - 1, -((r.top + r.height / 2) / window.innerHeight * 2 - 1));
      const dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right);
      const dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
      madness.setProximity(1 - Math.hypot(dx, dy) / PROXIMITY_RANGE);
    };
    window.addEventListener('pointermove', onMove, {
      passive: true
    });
    return () => window.removeEventListener('pointermove', onMove);
  }, []);
  return (
    // Mobile: centred at the bottom, ~34px above the socials (which sit 56px up, ~22px tall);
    // desktop: top-right corner
    <header className="absolute inset-x-0 bottom-[7rem] z-30 md:relative md:inset-x-auto md:bottom-auto" data-id="element-138" data-mp="x8eb7ld2owp6">
      <nav aria-label="Main" className="flex items-start justify-center px-3 md:justify-end md:px-[1.6vw] md:py-[1.6vw]" data-id="element-139" data-mp="125nvynpiok6o">
        {/* Hover fade lives on the wrapper so it never fights the link's intro animation */}
        <div data-drone-push className="transition-opacity duration-300 ease-[cubic-bezier(0.25,1,0.5,1)] focus-within:opacity-[0.7] [@media(hover:hover)]:hover:opacity-[0.7] motion-reduce:transition-none" data-id="element-140" data-mp="9h8t0zjntsbp">
          <motion.a ref={contactRef} href="mailto:hey@laebel.co" onPointerEnter={madness.enter} onPointerLeave={madness.leave} onClick={madness.click} className="inline-flex h-[3.25rem] items-center whitespace-nowrap rounded-full bg-black px-8 text-[1.125rem] md:h-[clamp(2.5rem,3.2vw,3rem)] md:px-[clamp(1.25rem,1.8vw,1.75rem)] md:text-[clamp(0.875rem,1.15vw,1.05rem)] font-semibold leading-[1.2] tracking-[-0.03em] text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black" key={mobile ? 'm' : 'd'} {...mobile ? {} : focusIn(INTRO.links, reduce, {
            y: 6,
            blur: 6,
            duration: 1.1
          })} data-id="element-141" data-mp="1cspeft8vteax">
            hey@laebel.co
          </motion.a>
        </div>
      </nav>
    </header>
  );
}